import React from 'react';

export function FollowUpView({ imagePreview, totals, questions, currentQ, handleAnswer }) {
  return (
    <div className="animate-slide-up-spring" key={currentQ}>
      <div className="relative mb-6">
        <img src={imagePreview} alt="Meal" className="w-full aspect-[4/3] object-cover rounded-2xl opacity-40" />
        <div className="absolute bottom-4 left-4 right-4 rounded-2xl p-4 shadow-lg" style={{ background: '#FFFFFF', border: '1px solid #E8E0D8' }}>
          <div className="text-center">
            <span className="text-3xl font-bold" style={{ color: '#2C2C2C' }}>{Math.round(totals.calories)}</span>
            <span className="text-sm ml-1" style={{ color: '#9A8F87' }}>cal</span>
          </div>
        </div>
      </div>

      <div className="rounded-2xl p-6" style={{ background: '#FFFFFF', border: '1px solid #E8E0D8', boxShadow: '0 4px 20px -4px rgba(0,0,0,0.06)' }} data-testid="question-card">
        <div className="flex items-center gap-2 mb-4">
          <div className="text-xs font-medium" style={{ color: '#9A8F87', fontFamily: 'var(--font-sans)', letterSpacing: '0.08em', textTransform: 'uppercase', fontSize: 11 }}>
            Question {currentQ + 1} of {questions.length}
          </div>
          <div className="flex-1" />
          <div className="flex gap-1.5">
            {questions.map((_, i) => (
              <div key={`dot-${i}`} className="w-2 h-2 rounded-full" style={{ background: i <= currentQ ? '#C67A5C' : '#E8E0D8' }} />
            ))}
          </div>
        </div>

        <p style={{ fontFamily: 'var(--font-serif)', fontSize: 20, fontWeight: 400, color: '#2C2C2C', marginBottom: 24, lineHeight: 1.4 }}>
          {questions[currentQ].text}
        </p>

        <div className="space-y-3">
          {questions[currentQ].options?.map((opt, i) => (
            <button key={`opt-${opt.label}`} data-testid={`followup-option-${i}`}
              onClick={() => handleAnswer(questions[currentQ].id, opt)}
              className="w-full p-4 rounded-xl text-left transition-all"
              style={{ minHeight: 52, background: '#FFFFFF', border: '1px solid #E8E0D8', cursor: 'pointer' }}
              onMouseOver={e => { e.currentTarget.style.background = 'rgba(198,122,92,0.08)'; e.currentTarget.style.borderColor = '#C67A5C'; }}
              onMouseOut={e => { e.currentTarget.style.background = '#FFFFFF'; e.currentTarget.style.borderColor = '#E8E0D8'; }}>
              <div className="flex justify-between items-center">
                <span style={{ fontFamily: 'var(--font-sans)', fontSize: 15, fontWeight: 500, color: '#2C2C2C' }}>{opt.label}</span>
                {opt.calorie_adjustment !== 0 && (
                  <span style={{ fontSize: 13, fontWeight: 600, color: opt.calorie_adjustment > 0 ? '#C67A5C' : '#5A8C6A' }}>
                    {opt.calorie_adjustment > 0 ? '+' : ''}{opt.calorie_adjustment} cal
                  </span>
                )}
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
